import { AUTH_BASE_URL } from "../constants/constants";
import { sendRequest } from "../utils/sendAPI";
import { getToken } from "./authApi";

export const getBookingById = async (id) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/bookings/${id}`,
      method: "GET",
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching booking:", err);
    throw err;
  }
};

export const getRecentBookings = async () => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/bookings/recent`,
      method: "GET",
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching booking:", err);
    throw err;
  }
};

export const getTodayBookings = async ({ page, size }) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const params = new URLSearchParams({});

    if (page) params.append("page", page);
    if (size) params.append("size", size);

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/bookings/today?${params.toString()}`,
      method: "GET",
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching booking:", err);
    throw err;
  }
};

export const getBookings = async ({ keyword, status, page, size, date }) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const params = new URLSearchParams({
      page: page,
      size: size,
    });

    if (keyword) params.append("keyword", keyword);
    if (status) params.append("status", status);
    if (date) params.append("date", date); // yyyy-mm-dd

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/bookings?${params.toString()}`,
      method: "GET",
      token: token,
    });

    return res;
  } catch (err) {
    console.error("Error fetching booking:", err);
    throw err;
  }
};

export const createBooking = async (body) => {
  try {
    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/bookings/create`,
      method: "POST",
      body: body,
    });
    return res;
  } catch (err) {
    console.error("Error fetching booking:", err);
    throw err;
  }
};

export const updateBooking = async (id, body) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/bookings/${id}`,
      method: "PUT",
      body: body,
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching booking:", err);
    throw err;
  }
};

export const updateFullBooking = async (id, body) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/bookings/${id}/full`,
      method: "PUT",
      body: body,
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching booking:", err);
    throw err;
  }
};

export const deleteBooking = async (id) => {
  try {
    const token = getToken();
    if (!token) throw new Error("Token missing or expired");

    const res = await sendRequest({
      url: `${AUTH_BASE_URL}/authentication/bookings/${id}`,
      method: "DELETE",
      token: token,
    });
    return res;
  } catch (err) {
    console.error("Error fetching booking:", err);
    throw err;
  }
};
